import axios from 'axios';
import { BASEURL } from 'baseUrl';
import { toast } from 'react-toastify';

export const PURCHASE_REPORT = 'PURCHASE_REPORT';
export const PURCHASE_EXCEL = 'PURCHASE_EXCEL';
export const SALES_REPORT = 'SALES_REPORT';
export const SALES_EXCEL = 'SALES_EXCEL';
export const STOCK_REPORT = 'STOCK_REPORT';
export const LOW_REPORT = 'LOW_REPORT';
export const PRODUCT_REPORT = 'PRODUCT_REPORT';
export const PRODUCT_EXCEL = 'PRODUCT_EXCEL';
export const PARTY_REPORT = 'PARTY_REPORT';
export const MEDICINE_PURCHASE_REPORT = 'MEDICINE_PURCHASE_REPORT';
export const MEDICINE_PURCHASE_EXCEL = 'MEDICINE_PURCHASE_EXCEL';
export const PRODUCT_BATCH_REPORT = 'PRODUCT_BATCH_REPORT';

const purchaseReportsAction = (payload) => ({
  type: PURCHASE_REPORT,
  payload: payload,
});
const purchaseExcelAction = (payload) => ({
  type: PURCHASE_EXCEL,
  payload: payload,
});
const salesReportsAction = (payload) => ({
  type: SALES_REPORT,
  payload: payload,
});
const salesExcelAction = (payload) => ({ type: SALES_EXCEL, payload: payload });
const stockReportsAction = (payload) => ({
  type: STOCK_REPORT,
  payload: payload,
});
const lowReportsAction = (payload) => ({ type: LOW_REPORT, payload: payload });
const productReportsAction = (payload) => ({
  type: PRODUCT_REPORT,
  payload: payload,
});
const productExcelAction = (payload) => ({
  type: PRODUCT_EXCEL,
  payload: payload,
});
const partyReportsAction = (payload) => ({
  type: PARTY_REPORT,
  payload: payload,
});
const medicinePurchaseReportsAction = (payload) => ({
  type: MEDICINE_PURCHASE_REPORT,
  payload: payload,
});
const medicinePurchaseExcelAction = (payload) => ({
  type: MEDICINE_PURCHASE_EXCEL,
  payload: payload,
});
const productBatchReportsAction = (payload) => ({
  type: PRODUCT_BATCH_REPORT,
  payload: payload,
});

export const purchaseReports = (payload, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/reports/purchase-report?specificDate=${payload.date}&startDate=${payload.startDate}&endDate=${payload.endDate}&search=${payload.search}&page=${limits.page}&limit=${limits.limit} `,
        )
        .then((res) => {
          dispatch(purchaseReportsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(purchaseReportsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const purchaseExcel = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/reports/purchase-report-export?specificDate=${payload.date}&startDate=${payload.startDate}&endDate=${payload.endDate}&search=${payload.search}`,
        )
        .then((res) => {
          dispatch(purchaseExcelAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(purchaseExcelAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const salesReports = (payload, limits) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    try {
      await axios
        .get(
          `${BASEURL}/reports/sales-report?specificDate=${payload.date}&startDate=${payload.startDate}&endDate=${payload.endDate}&search=${payload.search}&page=${limits.page}&limit=${limits.limit}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        )
        .then((res) => {
          dispatch(salesReportsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(salesReportsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const salesExcel = (payload) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    try {
      await axios
        .get(
          `${BASEURL}/reports/sales-report-export?specificDate=${payload.date}&startDate=${payload.startDate}&endDate=${payload.endDate}&search=${payload.search}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        )
        .then((res) => {
          dispatch(salesExcelAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(salesExcelAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const stockReports = () => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/reports/batch-report`)
        .then((res) => {
          dispatch(stockReportsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(stockReportsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const lowReports = () => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/reports/batch-report?quantityThreshold=10`)
        .then((res) => {
          dispatch(lowReportsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(lowReportsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const productReports = (payload, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/reports/product-report?search=${payload.search}&page=${limits.page}&limit=${limits.limit}`,
        )
        .then((res) => {
          dispatch(productReportsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(productReportsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const productExcel = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/reports/product-report-export?search=${payload.search}`,
        )
        .then((res) => {
          dispatch(productExcelAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(productExcelAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const partyReports = ({
  partyId,
  date,
  startDate,
  endDate,
  search,
  page,
  limit,
}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams();
      if (partyId) query.append('partyId', partyId);
      if (date) query.append('date', date);
      if (startDate) query.append('startDate', startDate);
      if (endDate) query.append('endDate', endDate);
      if (search) query.append('search', search);
      query.append('page', page || 1);
      query.append('limit', limit || 10);

      const res = await axios.get(
        `${BASEURL}/reports/party-wise-purchase-report?${query.toString()}`,
      );
      dispatch(partyReportsAction(res));
    } catch (error) {
      console.error('Error in partyReports:', error);
      dispatch(partyReportsAction(error?.response));
      toast.error(
        error?.response?.data?.message || 'Failed to fetch party reports',
      );
    }
  };
};

export const getMedicinePurchaseReport = ({
  date,
  startDate,
  endDate,
  partyId,
  search,
  page = 1,
  limit = 10,
}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams();
      if (date) query.append('date', date);
      if (startDate) query.append('startDate', startDate);
      if (endDate) query.append('endDate', endDate);
      if (partyId) query.append('partyId', partyId);
      if (search) query.append('search', search);
      query.append('page', page);
      query.append('limit', limit);

      const response = await axios.get(
        `${BASEURL}/reports/medicine-purchase-report?${query.toString()}`,
      );
      dispatch({
        type: MEDICINE_PURCHASE_REPORT,
        payload: response.data,
      });
    } catch (error) {
      console.error('Error fetching medicine purchase report:', error);
      dispatch({
        type: MEDICINE_PURCHASE_REPORT,
        payload: {
          success: false,
          message: error.response?.data?.message || 'Failed to fetch data',
        },
      });
      toast.error(error.response?.data?.message || 'Failed to fetch data');
    }
  };
};

export const getMedicinePurchaseReportExcel = ({
  date,
  startDate,
  endDate,
  partyId,
  search,
}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams();
      if (date) query.append('date', date);
      if (startDate) query.append('startDate', startDate);
      if (endDate) query.append('endDate', endDate);
      if (partyId) query.append('partyId', partyId);
      if (search) query.append('search', search);

      const response = await axios.get(
        `${BASEURL}/reports/medicine-purchase-report-export?${query.toString()}`,
      );
      dispatch({
        type: MEDICINE_PURCHASE_EXCEL,
        payload: response.data,
      });
    } catch (error) {
      console.error('Error fetching medicine purchase report:', error);
      dispatch({
        type: MEDICINE_PURCHASE_EXCEL,
        payload: {
          success: false,
          message: error.response?.data?.message || 'Failed to fetch data',
        },
      });
      toast.error(error.response?.data?.message || 'Failed to fetch data');
    }
  };
};

export const getProductBatchReport = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${BASEURL}/reports/product-batch-report`,
      );
      dispatch({
        type: PRODUCT_BATCH_REPORT,
        payload: response.data,
      });
    } catch (error) {
      console.error('Error fetching product batch report:', error);
      dispatch({
        type: PRODUCT_BATCH_REPORT,
        payload: {
          success: false,
          message: 'Failed to fetch data',
        },
      });
      toast.error('Failed to fetch data');
    }
  };
};
